import Faq from '../views/faq'
import Home from '../views/home'
import Abouts from '../views/abouts'
import NotFound from '../views/404'
import ContactUs from '../views/contact_us'
import CategoryDetails from '../views/category_details'
import CategoryDetailsVideo from '../views/category_details_video'

////////////////////////////////////////////////////////////////////

export const HOME = '/'
export const FAQ = '/faq'
export const NOT_FOUND = '*'
export const ABOUTS = '/abouts'
export const CONTACT_US = '/contact-us'
export const CATEGORY_DETAILS = '/category-details/:id'
export const CATEGORY_DETAILS_VIDEO = '/category-details-video/:id'

////////////////////////////////////////////////////////////////////

export const routerList = [
    { router: FAQ, page: <Faq /> },
    { router: HOME, page: <Home /> },
    { router: ABOUTS, page: <Abouts /> },
    { router: CONTACT_US, page: <ContactUs /> },
    { router: CATEGORY_DETAILS, page: <CategoryDetails /> },
    { router: CATEGORY_DETAILS_VIDEO, page: <CategoryDetailsVideo /> },
    { router: NOT_FOUND, page: <NotFound /> },
]